var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":"","color":"primary","title":_vm.title},on:{"click":_vm.click}},[_c('v-icon',{staticClass:"uikit-icon size-20",class:_vm.icon})],1)}
var staticRenderFns = []

export { render, staticRenderFns }